 

export const GetElearningData = async (crsnum) => {
 
    return fetch(`api/class/MaterialAssigments/${crsnum}`)
        .then(handleResponse)

        .then(response => response.json())
         
  
}
 
const handleResponse = (response) => {

    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            console.log(this.props)
            window.location = "http://www.google.com"
        }


        return Promise.reject();
    }
    return Promise.resolve(response)


}




// WEBPACK FOOTER //
// ./src/pages/course/E-Learning/API.js